"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var BadgeSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M8.5,14.0522345 L6.27686907,14.608002 L4.93109248,12.7532584 L2.87083488,11.75 L3.03211645,9.4641354 L2.09874961,7.37128685 L3.6916239,5.72388277 L4.32188054,3.52071112 L6.60102397,3.28260624 L8.5,2 L10.398976,3.28260624 L12.6781195,3.52071112 L13.3083761,5.72388277 L14.9012504,7.37128685 L13.9678836,9.4641354 L14.1291651,11.75 L12.0689075,12.7532584 L10.7231309,14.608002 L8.5,14.0522345 Z M8.5,13.0214597 L10.3104057,13.4740488 L11.4063383,11.9636391 L13.0841082,11.1466361 L12.9527686,9.28514324 L13.7128555,7.58083293 L12.415699,6.23927014 L11.9024498,4.44511827 L10.0464303,4.25121767 L8.5,3.20672784 L6.9535697,4.25121767 L5.09755024,4.44511827 L4.58430102,6.23927014 L3.28714453,7.58083293 L4.04723142,9.28514324 L3.91589184,11.1466361 L5.59366172,11.9636391 L6.6895943,13.4740488 L8.5,13.0214597 Z M6.85355339,8.14644661 L7.5,8.79289322 L10.1464466,6.14644661 C10.3417088,5.95118446 10.6582912,5.95118446 10.8535534,6.14644661 C11.0488155,6.34170876 11.0488155,6.65829124 10.8535534,6.85355339 L7.5,10.2071068 L6.14644661,8.85355339 C5.95118446,8.65829124 5.95118446,8.34170876 6.14644661,8.14644661 C6.34170876,7.95118446 6.65829124,7.95118446 6.85355339,8.14644661 Z" })));
};
BadgeSmall.displayName = 'BadgeSmall';
exports.default = BadgeSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=BadgeSmall.js.map